import { render, staticRenderFns } from "./AppDashboardNumericData.vue?vue&type=template&id=bb69b70a"
import script from "./AppDashboardNumericData.vue?vue&type=script&lang=js"
export * from "./AppDashboardNumericData.vue?vue&type=script&lang=js"
import style0 from "./AppDashboardNumericData.vue?vue&type=style&index=0&id=bb69b70a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports